import dateUtils from '@/common/dateUtils';

export default {
  /**
   * Year and month in String form ${year}_${month_zero_based}
   * @param yearMonth - year and month in format  ${year}_${month_zero_based}
   * @param locale - the locale used for formatting
   * @returns {string}
   */
  getMonthTitle(yearMonth, locale) {
    let yearAndMonth = yearMonth.split('_');

    let date = new Date(Number(yearAndMonth[0]), Number(yearAndMonth[1]), 2); // use second day of month to avoid time zone shifted dates
    return dateUtils.formatAsLocaleYearAndMonth(date, locale);
  },
};
